import components from './_components';
import mixins from './../_mixins-missmatch-monitor';
import methods from './_methods';

export default {
    name: 'TabAccountsDetails',
    mixins: [mixins],
    components,
    methods,
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            keyUpdate: 0,
            productSelected: false,
            actionSelected: 'ninguna',
            mismatchesItemSelected: [],
            checksActivated: false,
            itemsToFusionFromLastMovements: [],
            operationToFusionWithMovements: null
        };
    },
    mounted() {
        this.$root.$on('productSelected', key_product => {
            this.productSelected = this.item.comparisons.find(comparison => comparison.key_product === key_product);
        });
        this.$root.$on('showModalWarningAction', payload => {
            this.actionSelected = payload.type || 'nada';
            this.mismatchesItemSelected = [payload.item];
            if (payload.show || payload) {
                this.$bvModal.show('modalWarningAction');
            } else {
                this.$bvModal.hide('modalWarningAction');
            }
        });
        this.$root.$on('createFusionOperation', item => {
            if (item[0]?._origin === 'tab-accounts-details') {
                this.createFusion(item);
            }
        });
        this.$root.$on('addOperation', item => {
            if (item[0]?._origin === 'tab-accounts-details') {
                this.addOperation(item);
            }
        });
        this.$root.$on('checksActivated', payload => {
            this.checksActivated = payload.status;
            this.operationToFusionWithMovements = payload.item;
        });
        this.$root.$on('addMovementToFusion', payload => {
            if (payload.status) {
                this.itemsToFusionFromLastMovements.push(payload.item);
            } else {
                const index = this.itemsToFusionFromLastMovements.indexOf(payload.item);
                this.itemsToFusionFromLastMovements.splice(index, 1);
            }
        });
    },
    beforeDestroy() {
        this.$root.$off('productSelected');
        this.$root.$off('showModalWarningAction');
        this.$root.$off('createFusionOperation');
        this.$root.$off('addOperation');
        this.$root.$off('checksActivated');
        this.$root.$off('addMovementToFusion');
    },
    computed: {
        fields() {
            return [
                {
                    name: 'Titulares',
                    value: this.getListHolders(this.item.holders)
                },
                {
                    name: 'Cuenta',
                    value: this.item.account
                }
            ];
        }
    }
};
